import React from "react";
import TypesOfCaregiversModel from "../ModelLayouts/TypesOfCaregiversModel";
import Icon from "../ui/Icon";
import { Link } from "react-router-dom";
import FamilyCaregiving from "../DetailsSubSections/TypesOfCaregivers/FamilyCaregiving";
import FootInfo from "../ui/FootInfo";

const TypesOfCaregiversDetail = () => {
  const scrollToSectionEnd = () => {
    const element = document.getElementById("read-more-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div>
      <div className="mb-10 lg:mb-20">
        <div className="flex gap-4 items-center justify-end mt-2 lg:hidden">
          <div className="flex items-center justify-center">
            <img
              src="/assets/img/mobile-layout/mobile-toc.png"
              alt="Types of caregivers mobile"
            />
          </div>
          <button onClick={scrollToSectionEnd}>
            <Icon
              src="/assets/svgs/back_btn.svg"
              alt="Bottom button"
              className="-rotate-90"
            />
          </button>
        </div>

        <section className="relative hidden lg:block">
          <TypesOfCaregiversModel />
          <div className="absolute top-1/2 -translate-y-1/2 right-5 z-10">
            <button onClick={scrollToSectionEnd}>
              <Icon
                src="/assets/svgs/back_btn.svg"
                alt="Bottom button"
                className="-rotate-90"
              />
            </button>
          </div>
        </section>
      </div>

      <section
        className="grid lg:grid-cols-2 gap-5 scroll-mt-10 pb-10"
        id="read-more-section"
      >
        <div className="hidden lg:block lg:col-span-1 h-fit sticky top-24 self-start">
          <div className="relative">
            <div className="[zoom:0.45] xl:[zoom:0.6] 2xl:[zoom:0.75]">
              <TypesOfCaregiversModel
                className="[zoom:0.45] xl:[zoom:0.6] 2xl:[zoom:0.75]"
                showTooltips={false}
              />
            </div>
            <div>
              <div className="absolute bottom-10 right-20 z-10">
                <Link to="/zoom-in-types-of-caregivers">
                  <Icon
                    src="/assets/svgs/zoomIn_btn.svg"
                    alt="Zoom in button"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="space-y-12">
            <FamilyCaregiving />
            <FootInfo />
          </div>
        </div>
      </section>
    </div>
  );
};

export default TypesOfCaregiversDetail;
